import React from "react";
import { format } from "date-fns";
import { API_LINK } from "../../../utils/fetch.util";
import Image from "../../../components/Image/Image.component";

interface ConfirmationCardProps {
  name: string;
  profilePicUrl: string;
  createdAt: string;
  status: string;
}

const ConfirmationCard: React.FC<ConfirmationCardProps> = ({
  name,
  profilePicUrl,
  createdAt,
  status,
}) => {
  return (
    <div className="border rounded-lg shadow-sm p-4 bg-white flex flex-col items-start w-fit">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          <div 
            className={`rounded-full p-2 mr-2 ${status === "confirmed" 
              ? "bg-green-100 text-green-600" 
              : status === "delayed" 
                ? "bg-orange-100 text-orange-600" 
                : "bg-red-100 text-red-600"}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              {status === "confirmed" ? (
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              ) : status === "delayed" ? (
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clipRule="evenodd"
                />
              ) : (
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              )}
            </svg>
          </div>
          <span className={`font-medium ${status === "confirmed" 
            ? "text-green-600" 
            : status === "delayed" 
              ? "text-orange-600" 
              : "text-red-600"}`}>
            {status}
          </span>
        </div>
      </div>
      <div className="flex-grow flex flex-col items-center">
        <div className="w-full rounded-md overflow-hidden mb-2">
          <Image
            src={`${profilePicUrl}` || "/default-avatar.png"}
            alt={name}
            className="size-[224px] object-cover"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = "/default-avatar.png";
            }}
          />
        </div>
        <h3 className="font-medium text-lg mb-2">{name}</h3>
        <p className="text-sm text-amber-700 font-medium">
          {createdAt ? format(new Date(createdAt), "hh:mm a") : ""}
        </p>
      </div>
    </div>
  );
};

export default ConfirmationCard;
